import { buildService } from './service';
import serviceMethods from './service_methods';
import { useCallback } from 'react';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

const api = buildService(
  '/users/confirmation',
  { only: ['get', 'create'] }
);

const useConfirmEmail = ({ setLoading, onSuccess, onError }) => {
  const callback = useCallback(
    async (confirmationToken) => {
      console.log('📧 ConfirmationService: Confirming email with token');
      const response = await fetch(`${baseUrl}/api/users/confirmation?confirmation_token=${confirmationToken}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.status?.message || 'Failed to confirm email');
      }

      const result = await response.json();
      console.log('✅ ConfirmationService: Email confirmed successfully', result);
      return result;
    },
    []
  );

  return serviceMethods.useHttpCallback({
    callback,
    setLoading,
    onSuccess,
    onError
  });
};

const useResendConfirmation = ({ setLoading, onSuccess, onError }) => {
  const callback = useCallback(
    async (email) => {
      console.log('📧 ConfirmationService: Resending confirmation for', email);
      const result = await api.create({ user: { email } });
      console.log('✅ ConfirmationService: Confirmation resent', result);
      return result;
    },
    []
  );

  return serviceMethods.useCreate({
    callback,
    setLoading,
    onSuccess,
    onError
  });
};

// Direct methods for non-hook usage
const confirmEmail = async (confirmationToken) => {
  console.log('📧 ConfirmationService: Direct email confirmation');
  const response = await fetch(`${baseUrl}/api/users/confirmation?confirmation_token=${confirmationToken}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.status?.message || 'Failed to confirm email');
  }

  const result = await response.json();
  console.log('✅ ConfirmationService: Direct confirmation successful', result);
  return result;
};

const resendConfirmation = async (email) => {
  console.log('📧 ConfirmationService: Direct resend confirmation', email);
  const result = await api.create({ user: { email } });
  console.log('✅ ConfirmationService: Direct resend successful', result);
  return result;
};

const confirmationService = {
  // Hook-based methods for components
  useConfirmEmail,
  useResendConfirmation,
  
  // Direct methods for non-hook usage
  confirmEmail,
  resendConfirmation
};

export default confirmationService; 
